import { FC } from 'react';
import Ninja from 'assets/images/ninja_icon.png';
import NinjaSelected from 'assets/images/ninja_selected_icon.png';

const NinjaIcon: FC<{ isSelected: boolean }> = ({ isSelected }) => {
  return (
    <>
      {isSelected ? (
        <img src={NinjaSelected} alt="ninjaIcon" />
      ) : (
        <img src={Ninja} alt="ninjaIcon" />
      )}
    </>
  );
};

export default NinjaIcon;
